// imports
import * as Utils from './assets/js/opencode/utils'
import AuthService from './assets/js/opencode/auth'
import AuditService from './assets/js/opencode/audit'
import ExtendableError from './assets/js/opencode/error'
import Collection from './assets/js/opencode/collection'
import Inflector from './assets/js/opencode/inflector'

window.OCUtilsVersion = '1.3.0'

// register globals
window.d = Utils.d
window.w = Utils.w
window.ww = Utils.ww
window.typeOf = Utils.typeOf
window.isEmpty = Utils.isEmpty
window.inArray = Utils.inArray
window.isArray = Utils.isArray
window.isObject = Utils.isObject
window.fromJson = Utils.fromJson
window.toJson = Utils.toJson
window.arrayFromObject = Utils.arrayFromObject
window.arrayUniquePush = Utils.arrayUniquePush
window.deleteFromArray = Utils.deleteFromArray
window.cloneObject = Utils.cloneObject
window.is = Utils.is

// exports
export * from './assets/js/opencode/api/RequestService'
export * from './assets/js/opencode/api/APIService'
export * from './assets/js/opencode/api/APIServiceError'
export * from './assets/js/opencode/api/ResponseDTO'

export * from './assets/js/opencode/utils'
export {
    Collection,
    AuthService,
    AuditService,
    Inflector,
    ExtendableError
}
